import { Component } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { CookieService } from 'ngx-cookie-service';
import { EncryptDecryptService } from 'src/app/shared/services/encrypt-decrypt.service';

@Component({
  selector: 'app-access-denied',
  templateUrl: './access-denied.component.html',
  styleUrls: ['./access-denied.component.css'],
  standalone: false
})
export class AccessDeniedComponent {

  session: any;

  constructor(private router: Router, private enc: EncryptDecryptService) {
    this.session = JSON.parse(this.enc.decryptUsingAES256(sessionStorage.getItem(this.enc.encryptUsingAES256('esstoken'))));
    // console.log(this.session);
    // this.getTokenFlag = getToken;
  }

  fnBackToHome() {
    const isShow = localStorage.getItem(this.enc.encryptUsingAES256('Is_From_ChatBot')) === 'true' ? true : false;
    if (isShow) {
      this.router.navigate(['/Public/Onboarding/home']);
    } else {
      if (this.session[0].isESS === 'ESS') {
        if ((this.session[0].isOfferReleased === 1 || this.session[0].isHRLetterReleased === 1 || this.session[0].isAssetLetterReleased === 1) || (this.session[0].restrictEmpLogin)) {
          const pwdInfo: any = {};
          this.router.navigate(['/Offer-Acceptance'], { queryParams: { isPasswdInfo: btoa(JSON.stringify(pwdInfo)), } });
        } else {
          const pwdInfo: any = {};
          this.router.navigate(['/ESS-Home'], { queryParams: { isPasswdInfo: btoa(JSON.stringify(pwdInfo)), } });
        }
      } else {
        if ((this.session[0].isOfferReleased === 1 || this.session[0].isHRLetterReleased === 1 || this.session[0].isAssetLetterReleased === 1) || (this.session[0].restrictEmpLogin)) {
          const pwdInfo: any = {};
          this.router.navigate(['/Offer-Acceptance'], { queryParams: { isPasswdInfo: btoa(JSON.stringify(pwdInfo)), } });
        } else {
          const pwdInfo: any = {};
          this.router.navigate(['/home'], { queryParams: { isPasswdInfo: btoa(JSON.stringify(pwdInfo)), } });
        }
      }
    }
  }
}
